import React from 'react'
import styled from 'styled-components'
import Sprout from 'sprout'
import { countryOptions } from './helper/countries'
import { Grid, Row, Col } from 'rsuite'

export default function Form ({ onSubmit, key }) {
  
  const validateEmail = {
    value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i,
    message: "Dirección de correo inválida"
  }

  return (
    <Container>
      <Sprout theme={ Sprout.defaultTheme } onSubmit={onSubmit} key={key}>
        <Row >
          <Col xs={24} md={12} >
            <Sprout.Field input={Sprout.TextInput} placeholder="Nombre completo" name="FullName" validation={{ required: 'Este campo es requerido' }}/>
          </Col>
          <Col xs={24} md={12} >
            <Sprout.Field input={Sprout.TextInput} placeholder="Correo" name="Email" validation={{ required: 'Este campo es requerido', pattern: validateEmail }}/>
          </Col>
        </Row>
        
       
        <Sprout.Field name="Country" title="Elije un país" input={Sprout.Select} validation={{ required: 'Este campo es requerido' }}>
          {countryOptions.map( country => {
           return <option key={country.key} value={country.value}>{country.label}</option>
          })}
        </Sprout.Field>

        <Sprout.Field input={Sprout.TextArea} placeholder="Mensaje" name="Message" validation={{ required: 'Este campo es requerido' }}/>

        <div style={{ flex: 1, display: 'flex' }}>
          <Sprout.Button type="submit" >Enviar</Sprout.Button>
        </div>
      </Sprout>
    </Container>
  )
}

const Container = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
`
